// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".publish-display[data-v-19573d3d]{width:100px}@media only screen and (max-width:576px){.badge__tag-published[data-v-19573d3d]{font-size:55%!important}}", ""]);
// Exports
module.exports = exports;
